import React from "react";
import "./BodyDiagram.scss";

const SEL_FILL   = "#8fc98f";
const SEL_STROKE = "#3d8b3d";
const DEF_FILL   = "#c8d8ee";
const DEF_STROKE = "#7a9cbf";

export function BodyDiagram({ selectedParts = [], onToggle }) {
  const sel  = (part) => selectedParts.includes(part);
  const f    = (part) => sel(part) ? SEL_FILL   : DEF_FILL;
  const s    = (part) => sel(part) ? SEL_STROKE : DEF_STROKE;
  const sw   = 1.5;

  const click = (part) => (e) => {
    e.stopPropagation();
    onToggle(part);
  };

  return (
    <div className="body-diagram">
      <svg
        viewBox="0 0 120 245"
        className="body-diagram__svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* ── CABEZA ─────────────────────────── */}
        <circle
          cx="60" cy="20" r="17"
          fill={f("Cabeza")} stroke={s("Cabeza")} strokeWidth={sw}
          onClick={click("Cabeza")}
          className="body-diagram__region"
        >
          <title>Cabeza</title>
        </circle>

        {/* ── CARA (dentro de cabeza) ─────────── */}
        <ellipse
          cx="60" cy="24" rx="10" ry="9"
          fill={f("Cara")} stroke={s("Cara")} strokeWidth="1"
          onClick={click("Cara")}
          className="body-diagram__region"
        >
          <title>Cara</title>
        </ellipse>

        {/* ── OJOS (encima de cara) ───────────── */}
        <g onClick={click("Ojos")} className="body-diagram__region">
          <title>Ojos</title>
          <circle cx="54" cy="18" r="3.2" fill={f("Ojos")} stroke={s("Ojos")} strokeWidth="1" />
          <circle cx="66" cy="18" r="3.2" fill={f("Ojos")} stroke={s("Ojos")} strokeWidth="1" />
        </g>

        {/* ── CUELLO ─────────────────────────── */}
        <rect
          x="53" y="37" width="14" height="12" rx="3"
          fill={f("Cuello")} stroke={s("Cuello")} strokeWidth={sw}
          onClick={click("Cuello")}
          className="body-diagram__region"
        >
          <title>Cuello</title>
        </rect>

        {/* ── HOMBROS ────────────────────────── */}
        <g onClick={click("Hombros")} className="body-diagram__region">
          <title>Hombros</title>
          <ellipse cx="28" cy="58" rx="17" ry="11" fill={f("Hombros")} stroke={s("Hombros")} strokeWidth={sw} />
          <ellipse cx="92" cy="58" rx="17" ry="11" fill={f("Hombros")} stroke={s("Hombros")} strokeWidth={sw} />
        </g>

        {/* ── TRONCO / ESPALDA ───────────────── */}
        <rect
          x="38" y="49" width="44" height="52" rx="5"
          fill={f("Tronco/Espalda")} stroke={s("Tronco/Espalda")} strokeWidth={sw}
          onClick={click("Tronco/Espalda")}
          className="body-diagram__region"
        >
          <title>Tronco/Espalda</title>
        </rect>

        {/* ── BRAZOS ─────────────────────────── */}
        <g onClick={click("Brazos")} className="body-diagram__region">
          <title>Brazos</title>
          <rect x="11" y="57" width="15" height="52" rx="6" fill={f("Brazos")} stroke={s("Brazos")} strokeWidth={sw} />
          <rect x="94" y="57" width="15" height="52" rx="6" fill={f("Brazos")} stroke={s("Brazos")} strokeWidth={sw} />
        </g>

        {/* ── MANOS ──────────────────────────── */}
        <g onClick={click("Manos")} className="body-diagram__region">
          <title>Manos</title>
          <ellipse cx="18"  cy="117" rx="10" ry="11" fill={f("Manos")} stroke={s("Manos")} strokeWidth={sw} />
          <ellipse cx="102" cy="117" rx="10" ry="11" fill={f("Manos")} stroke={s("Manos")} strokeWidth={sw} />
        </g>

        {/* ── CADERAS ────────────────────────── */}
        <rect
          x="36" y="101" width="48" height="22" rx="5"
          fill={f("Caderas")} stroke={s("Caderas")} strokeWidth={sw}
          onClick={click("Caderas")}
          className="body-diagram__region"
        >
          <title>Caderas</title>
        </rect>

        {/* ── PIERNAS (muslos) ───────────────── */}
        <g onClick={click("Piernas")} className="body-diagram__region">
          <title>Piernas</title>
          <rect x="38" y="123" width="20" height="40" rx="6" fill={f("Piernas")} stroke={s("Piernas")} strokeWidth={sw} />
          <rect x="62" y="123" width="20" height="40" rx="6" fill={f("Piernas")} stroke={s("Piernas")} strokeWidth={sw} />
        </g>

        {/* ── RODILLAS ───────────────────────── */}
        <g onClick={click("Rodillas")} className="body-diagram__region">
          <title>Rodillas</title>
          <ellipse cx="48" cy="164" rx="13" ry="9" fill={f("Rodillas")} stroke={s("Rodillas")} strokeWidth={sw} />
          <ellipse cx="72" cy="164" rx="13" ry="9" fill={f("Rodillas")} stroke={s("Rodillas")} strokeWidth={sw} />
        </g>

        {/* ── PIERNAS (pantorrillas) ─────────── */}
        <g onClick={click("Piernas")} className="body-diagram__region">
          <rect x="40" y="173" width="16" height="32" rx="5" fill={f("Piernas")} stroke={s("Piernas")} strokeWidth={sw} />
          <rect x="64" y="173" width="16" height="32" rx="5" fill={f("Piernas")} stroke={s("Piernas")} strokeWidth={sw} />
        </g>

        {/* ── TOBILLOS ───────────────────────── */}
        <g onClick={click("Tobillos")} className="body-diagram__region">
          <title>Tobillos</title>
          <ellipse cx="48" cy="207" rx="9"  ry="7" fill={f("Tobillos")} stroke={s("Tobillos")} strokeWidth={sw} />
          <ellipse cx="72" cy="207" rx="9"  ry="7" fill={f("Tobillos")} stroke={s("Tobillos")} strokeWidth={sw} />
        </g>

        {/* ── PIES ───────────────────────────── */}
        <g onClick={click("Pies")} className="body-diagram__region">
          <title>Pies</title>
          <ellipse cx="43" cy="221" rx="14" ry="7" fill={f("Pies")} stroke={s("Pies")} strokeWidth={sw} />
          <ellipse cx="77" cy="221" rx="14" ry="7" fill={f("Pies")} stroke={s("Pies")} strokeWidth={sw} />
        </g>
      </svg>

    </div>
  );
}
